import React from "react";
import style from './CustomFalseCeiling.module.scss';
import { ReactComponent as ToggleDisabled } from '../../../assets/icons/toggleDisabled.svg'
import { ReactComponent as ToggleEnabled } from '../../../assets/icons/toggleEnabled.svg'

const CustomSOWView = (props: any) => {
  const { details, itemDetails, updateDetails } = props;
  
  return (
    <div className={style.sow_container}>
      {
        details?.options?.map((e, i) => (
          <div className={style.sow_toggle_button} key={i}>
            <div className={style.wrapper_div}>
              <p>{e?.label}</p>
              <div className={style.toggle_btn}>
                <span>Customer</span>
                {itemDetails?.[e?.id] ? <i onClick={() => updateDetails({ id: e.id, value: false })}><ToggleEnabled /></i> : <i onClick={() => updateDetails({ id: e.id, value: true })}><ToggleDisabled /></i>}
                <span>HomeLane</span>
              </div>
            </div>
          </div>
        ))
      }
    </div>
  )
}

export default CustomSOWView;